// ==========================================================
//  Cover-Star, Published-Date & Extra-Info bei Variantenwechsel
// ==========================================================
//
//  Aktualisiert bei jedem Variantenwechsel (Variant-Selector ODER
//  Media-Gallery-Bilder-Swipe):
//    – Cover-Star-Link ("Cover star: ...")
//    – Erscheinungsdatum ("Published on: ...")
//    – Extra-Info neben dem Preis (nur bei "vollständige jahre" / "legenden")
//
//  Auto-Scroll auf mobil nur bei Variant-Selector, nicht bei Bild-Swipe.

// LEON 2026-10-10: Debug-Ausgaben nur noch bei Bedarf (CVC_DEBUG = true setzen)
const CVC_DEBUG = false;
function cvcLog() { if (CVC_DEBUG) console.log.apply(console, arguments); }
function cvcWarn() { if (CVC_DEBUG) console.warn.apply(console, arguments); }

cvcLog('[CoverLink] Skript geladen');

// ---------- Datenquellen aus dem DOM lesen ----------

const dataScript = document.getElementById('variants-with-cover');
const variantData = dataScript ? JSON.parse(dataScript.textContent) : [];
cvcLog('[CoverLink] Geladene Variantendaten:', variantData);

const infoScript = document.getElementById('variants-with-extra-info');
const variantInfoData = infoScript ? JSON.parse(infoScript.textContent) : [];

// ---------- Helper-Funktionen ----------

// Metafield-Daten (Cover-Star + Handle) für eine Variante finden
function getVariantMeta(id) {
  return variantData.find(v => v.id == id);
}

// Extra-Info-Text für eine Variante finden
function getVariantInfo(id) {
  const found = variantInfoData.find(v => v.id == id);
  return found ? found.info : '';
}

// Prüfen, ob das Produkt die Tags für Extra-Info-Disclaimer hat
function productHasDynamicDisclaimerTags() {
  const wrapper = document.querySelector('.product-single');
  if (!wrapper) return false;
  const tags = (wrapper.dataset.productTags || '').toLowerCase();
  return tags.includes('vollständige jahre') || tags.includes('legenden');
}

// Aktuelle Variant-ID aus dem versteckten Input auslesen
function readCurrentVariantId() {
  const input = document.querySelector('input[name="id"]');
  return input ? input.value : null;
}

// ---------- Update-Funktionen ----------

// Cover-Star-Link ("Cover star: <Name>") aktualisieren
function updateCoverLink(variantId) {
  const linkWrapper = document.getElementById('variant-cover-link'); // <p>
  const link = document.getElementById('cover-link');                // <a>
  const span = document.querySelector('#cover-link .cover-text');    // <span>
  if (!linkWrapper || !link || !span) {
    cvcWarn('[CoverLink] Platzhalter nicht gefunden!');
    return;
  }

  const data = getVariantMeta(variantId);

  if (data && data.cover) {
    span.textContent = data.cover;
    link.href = '/collections/' + data.handle;
    linkWrapper.style.display = 'block';
    cvcLog('[CoverLink] Setze auf', data.cover, '→', link.href);
  } else {
    span.textContent = '';
    link.href = '#';
    linkWrapper.style.display = 'none';
    cvcLog('[CoverLink] Kein Metafield für Variante', variantId);
  }
}

// Extra-Info neben Preis aktualisieren
function updateVariantExtraInfo(variantId) {
  const infoSpan = document.getElementById('variant-extra-info');
  if (!infoSpan) return;

  // Ziel-HTML vorher bestimmen (verhindert Layout-Flash durch Zwischenzustand:
  // vorher wurde erst geleert/versteckt und dann neu befüllt — dazwischen
  // konnte der Browser rendern → sichtbarer CLS).
  let newHtml = '';
  if (productHasDynamicDisclaimerTags()) {
    newHtml = getVariantInfo(variantId) || '';
  }

  if (newHtml) {
    // Nur schreiben wenn tatsächlich anders (verhindert unnötigen Repaint)
    if (infoSpan.innerHTML !== newHtml) {
      infoSpan.innerHTML = newHtml;
    }
    if (infoSpan.style.display !== 'block') {
      infoSpan.style.display = 'block';
    }
  } else {
    // Kein Text → verstecken (nur wenn nicht bereits versteckt)
    if (infoSpan.innerHTML !== '') {
      infoSpan.innerHTML = '';
    }
    if (infoSpan.style.display !== 'none') {
      infoSpan.style.display = 'none';
    }
  }
}

// Veröffentlichungsdatum aktualisieren
function updateVariantPublishedDate(variantId) {
  const elWrapper = document.getElementById('variant-published-date');
  const elText = document.querySelector('#variant-published-date .published-date-text');
  const script = document.getElementById('variants-with-date');
  if (!elWrapper || !elText || !script) return;

  try {
    const data = JSON.parse(script.textContent);
    const item = data.find(v => String(v.id) === String(variantId));
    if (item && item.date) {
      elText.textContent = item.date;
      elWrapper.style.display = 'block';
    } else {
      elText.textContent = '';
      elWrapper.style.display = 'none';
    }
  } catch (e) {
    console.warn('[Datum] Fehler beim Parsen:', e);
  }
}

// ---------- CLS-Fix für Preis-Block ----------
//
// Der Preis-Block hat ein `data-updates-on-change`-Attribut, wodurch das Flow-Theme
// beim Variantenwechsel den kompletten inneren Content austauscht. Dabei fällt die
// Wrapper-Höhe kurz auf ~0 zurück und springt dann wieder auf normale Höhe →
// sichtbarer Layout-Shift ("Flackern"), besonders am "inkl. MwSt."-Text.
//
// Fix: min-height auf den Wrapper setzen, damit er während des Reloads nicht
// kollabiert. Progressive Höhen-Anpassung: min-height wird nie kleiner, nur größer.

function bumpPriceBlockMinHeight() {
  const priceWrapper = document.querySelector('[data-updates-on-change][data-block-id="price"]');
  if (!priceWrapper) return;
  const currentH = priceWrapper.getBoundingClientRect().height;
  const prevMin = parseFloat(priceWrapper.style.minHeight) || 0;
  if (currentH > prevMin) {
    priceWrapper.style.minHeight = currentH + 'px';
  }
}

// ---------- Zentrale Update-Funktion mit Duplikat-Schutz ----------
//
// Beim Variant-Selector-Klick feuert das Flow-Theme drei Events in Folge:
// variant:change → variant:updated → variant:change.
// Der Duplikat-Schutz verhindert, dass die Update-Funktionen mehrfach für
// dieselbe Variant-ID laufen.

let _lastAppliedVariantId = null;

function applyAllUpdates(variantId) {
  if (!variantId) return;
  const idStr = String(variantId);
  if (idStr === _lastAppliedVariantId) return; // schon aktualisiert, skip
  _lastAppliedVariantId = idStr;

  updateCoverLink(variantId);
  updateVariantExtraInfo(variantId);
  updateVariantPublishedDate(variantId);
}

// ---------- Initial beim Seitenaufruf ----------

document.addEventListener('DOMContentLoaded', () => {
  const id = readCurrentVariantId();
  if (id) applyAllUpdates(id);
  // Nach dem initialen Layout die Höhe des Preis-Blocks als min-height fixieren
  requestAnimationFrame(bumpPriceBlockMinHeight);
});

// ---------- Bei Variantenwechsel via Variant-Selector ----------
// Der Variant-Selector feuert 'variant:updated'.
// Auto-Scroll auf mobil, damit die neue Variante sichtbar wird.

window.eventBus.on('variant:updated', (context) => {
  const id = (context && context.variant && context.variant.id) || readCurrentVariantId();
  if (!id) return;

  setTimeout(() => {
    applyAllUpdates(id);
    bumpPriceBlockMinHeight();

    // Auto-Scroll bei mobiler Ansicht (nur bei Variant-Selector, nicht Media-Gallery)
    if (window.innerWidth <= 768) {
      const el = document.getElementById('productMediaMobile');
      if (el) {
        const offset = el.getBoundingClientRect().top + window.scrollY - 50;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      }
    }
  }, 50);
});

// ---------- Bei Variantenwechsel via Media-Gallery (Bild-Swipe) ----------
// Der Media-Gallery-Swipe im Flow-Theme feuert 'variant:change', nicht 'variant:updated'.
// Kein Auto-Scroll — der User ist bereits bei den Bildern.

window.eventBus.on('variant:change', (context) => {
  const id = (context && context.variant && context.variant.id) || readCurrentVariantId();
  if (!id) return;

  setTimeout(() => {
    applyAllUpdates(id);
    bumpPriceBlockMinHeight();
  }, 50);
});